import { logger } from './logger';
import { parseJwtPayload } from './parseJwtPayload';

export interface I2FaTokenData {
  '2fa_required': string;
}
export interface ISignupVerifyTokenData {
  verifyingEmail: boolean;
}
export interface IChangeEmailTokenData {
  changeEmail: true;
  new_email: string;
  used_at: string;
}

type TTokenData = unknown | I2FaTokenData | ISignupVerifyTokenData | IChangeEmailTokenData;

export const is2FaTokenData = (data: TTokenData): data is I2FaTokenData => {
  return (data as any)['2fa_required'] === 'true';
};

export const isSignupVerifyTokenData = (data: TTokenData): data is ISignupVerifyTokenData => {
  return (data as ISignupVerifyTokenData).verifyingEmail !== undefined;
};

export const isChangeEmailTokenData = (data: TTokenData): data is IChangeEmailTokenData => {
  return (data as IChangeEmailTokenData).changeEmail !== undefined;
};

export interface IAccessTokenPayload {
  data: unknown | I2FaTokenData | ISignupVerifyTokenData | IChangeEmailTokenData;
  email: string;
  exp: number;
  sub: string;
  user_id: string;
}

export const parseAccessToken = (token: string): IAccessTokenPayload => {
  try {
    return parseJwtPayload<IAccessTokenPayload>(token);
  } catch (e) {
    logger.error(e);
    throw new Error("Couldn't parse access token");
  }
};
